import { render, staticRenderFns } from "./TgUserFullNameWithLink.vue?vue&type=template&id=146f9666"
import script from "./TgUserFullNameWithLink.vue?vue&type=script&lang=js"
export * from "./TgUserFullNameWithLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports